import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const Statistics = ({ data }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('report');
  const handleView = () => {
    navigate('/report/bet-history', { state: { data } });
  };

  return (
    <div onClick={handleView} className="text-blue-400 hover:underline cursor-pointer text-center">
      <span>{t('xemchitiet')}</span>
    </div>
  );
};

export default Statistics;
